import { useInfiniteQuery } from '@tanstack/react-query'
import { personApi, PersonSearchParams, PersonsResponse } from '../services/api/persons'

export interface InfinitePersonsParams extends Omit<PersonSearchParams, 'page'> {
  // Remove page from params since we'll handle it internally
}

export function useInfinitePersons(params?: InfinitePersonsParams) {
  return useInfiniteQuery({
    queryKey: ['persons', 'infinite', params],
    queryFn: async ({ pageParam = 1 }: { pageParam: number }) => {
      return personApi.getPersons({
        ...params,
        page: pageParam,
        size: 20, // Fixed page size for infinite scroll
      })
    },
    getNextPageParam: (lastPage: PersonsResponse) => {
      // Return next page number if there are more pages
      if (lastPage.has_next) {
        return lastPage.page + 1
      }
      return undefined
    },
    initialPageParam: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    retry: (failureCount, error: any) => {
      // Don't retry validation errors (400-499) or after 1 failure
      if (error?.response?.status >= 400 && error?.response?.status < 500) {
        return false
      }
      // Only retry once for server errors
      return failureCount < 1
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  })
}
